import { render, staticRenderFns } from "./ReviewDialog2.vue?vue&type=template&id=41305bbd&scoped=true"
import script from "./ReviewDialog2.vue?vue&type=script&lang=ts"
export * from "./ReviewDialog2.vue?vue&type=script&lang=ts"
import style0 from "./ReviewDialog2.vue?vue&type=style&index=0&id=41305bbd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41305bbd",
  null
  
)

export default component.exports